// Copyright 2025, University of Maryland, All Rights Reserved
import { AxiosInstance } from 'axios';

// Global API instance - initialized by parent app
let globalApiInstance: AxiosInstance | null = null;

/**
 * Initialize the Workspaces API with the provided API instance
 * This should be called once by the parent application during startup
 */
export function initializeWorkspacesApi(api_instance: AxiosInstance) {
  globalApiInstance = api_instance;
  console.log('[Workspaces] API initialized with provided instance');
}

/**
 * Get the initialized workspaces API instance
 * @throws Error if not initialized
 */
export function getWorkspacesApi(): AxiosInstance {
  if (!globalApiInstance) {
    throw new Error('Workspaces API not initialized. Call initializeWorkspacesApi(apiInstance) first.');
  }
  return globalApiInstance;
}